export enum AccessRightType {
    UnAvailable = 0,
    Read = 10,
    Write = 20,
    Share = 30,
    Admin = 40,
    SuperAdmin = 50,
}
